import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { HTML_TYPE } from "../types.js";
import { HtmlViewer } from "./html-viewer.js";
const Html = ({ node, nodeIndex, NodeViewContainer }) => {
  const { iframeSandboxDomain, config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    HtmlViewer,
    {
      htmlData: node.htmlData,
      settings: config[HTML_TYPE],
      iframeSandboxDomain,
      isViewer: true
    }
  ));
};
var html_default = Html;
export {
  html_default as default
};
//# sourceMappingURL=html.js.map

import "@wix/ricos/css/plugin-html-viewer.global.css";